import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, ColumnLayout, FormField, Link, Modal, Select, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlert, mdiFileExcel, mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { addMonths, format, parse, subMonths } from 'date-fns';
import BadgeUserType from '../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import SelectUserType from '../../../../../components/selects/selectUserTypes';
import TableMovements from '../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemsMovement } from '../../../../../resources/types';
import { buildBreadcrumbItems, exportToExcel, formatCurrency, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';



export const ReportsFinancesRXPage = () => {

    const { menu, parameters } = useGlobalState();
    const [filteringText, setFilteringText] = useState("");
    const [users, setUsers] = useState<any[]>();
    const [type, setType] = useState({ label: "Solo deudores", value: "NEGATIVE" });
    const [idUserTypes, setIdUserTypes] = useState<number[]>([]);
    const [movements, setMovements] = useState<ItemsMovement[]>();


    const dateFrom = parameters.period ?
        format(
            subMonths(
                parse(
                    `01-${parameters.period.split("-")[1]}-${parameters.period.split("-")[0]}`,
                    "dd-MM-yyyy",
                    new Date()
                ),
                1
            ),
            "dd-MM-yyyy" // or "dd-MM-yyyy" depending on your requirements
        )
        : undefined;


    const dateFromBefore = parameters.period ?
        format(
            subMonths(
                parse(
                    `01-${parameters.period.split("-")[1]}-${parameters.period.split("-")[0]}`,
                    "dd-MM-yyyy",
                    new Date()
                ),
                2
            ),
            "dd-MM-yyyy" // or "dd-MM-yyyy" depending on your requirements
        )
        : undefined;
    const dateTo = parameters.period ? `15-${parameters.period.split("-")[1]}-${parameters.period.split("-")[0]}`
        : undefined;
    const handleMovements = async (report: any) => {
        try {
            setLoading(true);



            const dateStart = format(addMonths(parse(`01-${parameters.month.toString().padStart(2, '0')}-${parameters.year}`, 'dd-MM-yyyy', new Date()), -1), 'dd-MM-yyyy');
            const body = {
                idUser: report.idUser,
                dateStart: dateFromBefore,
                dateEnd: dateTo,
                orderBy: "dateTransaction",
                order: "asc",
                orderBy2: "idMovement",
                order2: "asc",
            };
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(body)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.movements)
                setMovements(data.movements)

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetDebt = async () => {
        try {
            setLoading(true);
            setUsers([]);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/reports/finance/duedebt',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    date: `01-${parameters.period.split("-")[1]}-${parameters.period.split("-")[0]}`,
                    debt: type.value === "NEGATIVE" ? -1 : 0,
                    ...(idUserTypes && idUserTypes.length > 0 && { idUserTypes })
                })
            });
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.users) {
                setUsers(data.users);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

    }, []);

    const [sortingColumn, setSortingColumn] = useState<any>({ sortingField: "displayName" });
    const [isDescending, setIsDescending] = useState(false);


    const filtered = useMemo(() => {
        //if (!filterAccountsPlans.trim()) return accountPlans;
        if (!users) return [];
        let filtered = users;

        if (filteringText.trim()) {
            const terms = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
            filtered = filtered.filter(item => {
                const haystack = [
                    item.displayName ?? "",
                    item.idUser ?? "",
                    item.idUserType.toString(),
                ].join(" ").toLowerCase();

                return terms.every(term => haystack.includes(term));
            });
        }

        return filtered;
    }, [users, filteringText]);
    const columns = useMemo(() => [
        {
            id: 'alert',
            header: '',
            cell: (item: any) => <>{item.debt <= -50000 ? <Icon path={mdiAlert} size={0.6} color="red" />
                : null}</>,
            maxWidth: 20
        },
        {
            id: 'displayName',
            header: 'Usuario',
            cell: (item: any) => <Link onClick={() => {
                handleMovements(item)
            }}>{item.displayName}</Link>,
            sortingField: "displayName",
        },
        {
            id: 'idUserType',
            header: 'Tipo',
            cell: (item: any) => <BadgeUserType idUserType={item.idUserType} type="min" />,
            sortingField: "idUserType",
            sortingComparator: (a: any, b: any) => a.idUserType - b.idUserType,
        },
        {
            id: 'balanceAtFrom',
            header: <FormField label="Saldo" constraintText={`Al ${dateFrom}`} />,
            cell: (item: any) => formatCurrency(item.balanceAtFrom, "CLP"),
            sortingField: "balanceAtFrom",
            sortingComparator: (a: any, b: any) => a.balanceAtFrom - b.balanceAtFrom,
        },
        {
            id: 'paymentsAfter',
            header: <FormField label="Pagos" constraintText={`Post ${dateFrom}`} />,
            sortingField: "paymentsAfter",
            sortingComparator: (a: any, b: any) => a.paymentsAfter - b.paymentsAfter,
            cell: (item: any) => formatCurrency(item.paymentsAfter, "CLP"),
        },
        {
            id: 'debt',
            header: <FormField label="Deuda" constraintText={`Al ${dateTo}`} />,
            sortingField: "debt",
            sortingComparator: (a: any, b: any) => a.debt - b.debt,
            cell: (item: any) => formatCurrency(item.debt, "CLP"),
        },
        {
            id: 'fine',
            header: "Multa",
            cell: (item: any) => item.fine < 0 ? formatCurrency(item.fine, "CLP") : "---",
            sortingField: "fine",
            sortingComparator: (a: any, b: any) => a.fine - b.fine,
        },
        {
            id: 'daysLastPayment',
            header: "DUP",
            cell: (item: any) => item.daysLastPayment === -1 ? "S/I" : item.daysLastPayment,
            sortingField: "daysLastPayment",
            sortingComparator: (a: any, b: any) => a.daysLastPayment - b.daysLastPayment,
        },
        {
            id: 'balance',
            header: <FormField label="Saldo" constraintText={`Al ${format(new Date(), "dd-MM-yyyy")}`} />,
            cell: (item: any) => formatCurrency(item.balance, "CLP"),
            sortingField: "balance",
            sortingComparator: (a: any, b: any) => a.balance - b.balance,
        },
        {
            id: 'sparckline',
            header: "",
            cell: (item: any) => <img src={`${getUrlVersion()}/resources/images/sparkline?idUser=${item.idUser}`} alt="Sparkline" />,
        },
    ], [filtered]);

    const sortedReport = useMemo(() => {
        const data = [...filtered]; // Create a copy of the filtered data to sort
        const { sortingField } = sortingColumn;

        const columnDefinition = columns.find(col => (col as any).sortingField === sortingField) as any;
        const comparator = columnDefinition?.sortingComparator;

        data.sort((a, b) => {
            let result = 0;
            if (comparator) {
                result = comparator(a, b);
            } else if (sortingField) {
                const valA = a[sortingField as keyof ReportList];
                const valB = b[sortingField as keyof ReportList];

                // Check if both values are numbers
                if (typeof valA === 'number' && typeof valB === 'number') {
                    result = valA - valB;
                } else {
                    // Fallback for strings
                    const strA = (valA ?? "").toString().toLowerCase();
                    const strB = (valB ?? "").toString().toLowerCase();
                    result = strA.localeCompare(strB);
                }
            }
            return isDescending ? -result : result;
        });

        return data;
    }, [filtered, sortingColumn, isDescending, columns]);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}
                        description="Permite calcular la deuda de un usuario en base el saldo al 1º del mes pasado, mas todos los abonos hasta el 15 del mes seleccionado. No se consideran los abonos por combustibles">
                        Radiografía de deuda vencida</Header>
                    <SpaceBetween direction='horizontal' size='xs'>
                        <FormField label={`Periodo`}>
                            <MPModal width={120} date={parameters.period} onConfirm={(obj) => {
                                setParameters({ ...parameters, month: obj.month, year: obj.year, period: obj.period });
                            }} />

                        </FormField>
                        <FormField label="Filtro">

                            <Select options={[
                                { "label": "Solo deudores", "value": "NEGATIVE" },
                                { "label": "Todos", "value": "ALL" },
                            ]}
                                onChange={({ detail }) => {
                                    setType({ value: detail.selectedOption.value, label: detail.selectedOption.label });
                                }}

                                selectedOption={type}
                            />
                        </FormField>

                        <FormField label="Tipo de usuario">
                            <SelectUserType
                                value={idUserTypes}
                                tokenLimit={0}
                                single={false} onSelect={(e) => {
                                    setIdUserTypes(e);
                                }} />

                        </FormField>
                        <FormField label="&nbsp;">
                            <Button style={{ root: btnIconForm }} onClick={() => handleGetDebt()}>
                                <Icon path={mdiMagnify} size={1} />
                            </Button>
                        </FormField>
                    </SpaceBetween>
                    {!!users && (
                        <SpaceBetween direction='vertical' size='xs'>
                            <Table
                                sortingColumn={sortingColumn}
                                sortingDescending={isDescending}
                                onSortingChange={(e) => {
                                    setSortingColumn(e.detail.sortingColumn);
                                    setIsDescending(e.detail.isDescending);
                                }}
                                stickyHeader
                                variant="embedded"
                                filter={
                                    <ColumnLayout columns={2} variant="text-grid">
                                        <div>
                                            <SpaceBetween direction="horizontal" size="xs">

                                                <TextFilter
                                                    disabled={!users || users.length === 0}
                                                    filteringPlaceholder="Filtrar"
                                                    filteringText={filteringText}
                                                    onChange={({ detail }) => setFilteringText(detail.filteringText)}
                                                />

                                                <Button disabled={users.length === 0} onClick={() => exportToExcel(users, `RX.Deuda.${parameters.period}.xlsx`)} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>

                                            </SpaceBetween>
                                        </div>
                                        {!!users && users.length > 0 && (
                                            <div>
                                                <Header variant="h3">
                                                    Deuda total: al {dateTo}: <em>{users.reduce((acc, user) => acc + (user.debt || 0), 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</em>
                                                </Header>
                                            </div>
                                        )}
                                    </ColumnLayout>

                                }
                                items={sortedReport || []}
                                columnDefinitions={columns}


                            />
                        </SpaceBetween>

                    )}
                    <Modal size="large" visible={!!movements} onDismiss={() => setMovements(undefined)} closeAriaLabel="Close modal"
                        header={<Header variant="h2"
                            description={`Entre el ${dateFromBefore} y el ${dateTo}`}
                        >Movimientos {movements && movements.length > 0 ? movements[0].displayName : null}</Header>}
                    >
                        <TableMovements movements={movements || []} visible={true}
                            showBalance
                            dateFilter="NONE" refresh={false} showUser={false}

                        />

                    </Modal>
                </SpaceBetween>
            }
        />
    )
};
